// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__8Cjqw","content":"style_content__E+2D9","spinner":"style_spinner__L4UMK","text":"style_text__tnm6j"};